import React, { useRef, useState } from 'react';
import { customUploadImage } from '../../../api/customAPI';
import NikkiWrapper from '../wrapper/NikkiWrapper';
import '../../../styles/components/selectbook/InsertPicture.scss';
import useAppTranslation from '../../../hooks/useAppTranslation';

export default function InsertPicture({
    onNext,
    onPrev,
    USER_ID,
    onAlert,
    onNextSound,
    onPrevSound,
}) {
    const { t } = useAppTranslation('components/selectbook/insertPicture');
    const fileRef = useRef(null);
    const [preview, setPreview] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleClickUpload = () => {
        fileRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setSelectedFile(file);
        const reader = new FileReader();
        reader.onload = () => {
            setPreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async () => {
        if (!selectedFile) {
            onAlert(t('alerts.uploadRequired'));
            return;
        }
        onNextSound?.();

        const formData = new FormData();
        formData.append('user_id', USER_ID);

        const timestamp = new Date().getTime();
        const fileName = `${timestamp}_${selectedFile.name}`;
        formData.append('file', selectedFile, fileName);

        const res = await customUploadImage(formData);

        if (res.success) {
            if (res.data) {
                onNext(res.data);
            } else {
                console.warn(
                    '[InsertPicture] success is true but data is missing',
                    res
                );
                onNext();
            }
        } else {
            onAlert(res.error || res.errMsg || t('alerts.uploadFailed'));
        }
    };

    return (
        <NikkiWrapper
            titleDescription={t('titleDescription')}
            progressValue="25"
            onNext={handleSubmit}
            onPrev={() => {
                onPrevSound?.();
                onPrev?.();
            }}
            showPrev={true}
            onNextSound={onNextSound}
            onPrevSound={onPrevSound}
        >
            <div className="picture-box">
                <div className="upload-area">
                    {preview ? (
                        <figure className="preview">
                            <img
                                src={preview}
                                alt={t('alts.preview')}
                            />
                        </figure>
                    ) : (
                        <div className="placeholder">
                            <figure>
                                <img
                                    src="/images/makingBranch/folder.svg"
                                    alt={t('alts.folder')}
                                />
                            </figure>
                            <p>{t('placeholder.title')}</p>
                            <span>{t('placeholder.tip')}</span>
                            <div className="privacy-notice-box">
                                <div className="notice-box-top">
                                    <figure>
                                        <img
                                            src={
                                                '/images/utils/icon/shield-notice.svg'
                                            }
                                            alt="shield-notice"
                                        />
                                    </figure>
                                    <h3>{t('upload.title_notice')}</h3>
                                </div>
                                <p>{t('upload.sub_desc_notice')}</p>
                                <button
                                    type="button"
                                    onClick={() =>
                                        window.open(
                                            'https://ai-magic4u.co.kr/terms?type=privacy',
                                            '_blank',
                                            'noopener,noreferrer'
                                        )
                                    }
                                >
                                    {t('upload.view_privacy_button')}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    ref={fileRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />

                <div
                    className="upload-btn"
                    onClick={handleClickUpload}
                >
                    <figure>
                        <img
                            src="/images/makingBranch/cloud.svg"
                            alt={t('alts.upload')}
                        />
                    </figure>
                    <p>{t('actions.upload')}</p>
                </div>
            </div>
        </NikkiWrapper>
    );
}
